import * as React from 'react';
import { useState, useEffect } from "react";
import Spinner from "../components/spinner.tsx";
import { editor, editorCode } from "../editor/editorFactory.ts";
import { renderEditorStateBrowser } from "../editor/renderEditorStateBrowser.ts";
import { isFunction } from "../helpers/utils.ts";
import type { PageData } from "../rest.interface";
import RenderContent from "./renderContent";
import renderContentCss from "./renderContentCss.tsx";
import { renderContentToHtmlString } from "./renderContentToHtmlString.ts";
import { fetchPageRenderReadyByUrl } from "./renderFunctionsData.ts";

type Props = Readonly<{
	url: string
}>;

function RenderPrepareContent({url}: Props) {
	const [page, setPage] = useState<PageData>(null);
	const [css, setCss] = useState("");

	useEffect(() => {
		fetchPageRenderReadyByUrl(url, {
			editor: editor,
			editorCode: editorCode,
			renderEditorState: renderEditorStateBrowser
		}).then((page: PageData) => {
			setPage(page);
		});
	}, [url]);

	useEffect(() => {
		if (window.initializeCountUp && isFunction(window.initializeCountUp)) {
			window.initializeCountUp();
		}

		renderContentCss(page?.content, renderContentToHtmlString).then((newCss) => {
			setCss(newCss);
		});
	}, [page]);

	return (<>
		{page !== null ? <RenderContent content={page?.content}/> : <div className="text-center my-16"><Spinner/></div>}
		<style>{css}</style>
		{/*<Dump value={page}/>*/}
	</>);
}

export default RenderPrepareContent;
